const classSingInStrictMode = {
  path: 'classSingInStrictMode/:classId/:signId',
  props: true,
  component: resolve => require(['../../../../components/pages/student_user/classSingIn/classSingInStrictMode'], resolve)
}
export default classSingInStrictMode



// WEBPACK FOOTER //
// ./src/router/pages/student_user/classSingIn/classSingInStrictMode.js